<template>
  <base-modal :width="420" :title="modalMessage ? modalMessage : 'Set your account password'" @closeModal="onCloseModal">
    <form
      action="/account/update/password"
      method="POST"
      class="wrapper"
      @submit.prevent="onSubmit"
    >
      <div class="field">
        <div class="control">
          <input
            id="new_password"
            type="password"
            class="text-input"
            :value="password"
            placeholder="Password"
            spellcheck="false"
            @input="password = $event.target.value"
          />
          <span v-if="formErrors.length" :class="['help is-danger']">
            {{ formErrors[0].password }}
          </span>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <input
            id="password_confirmation"
            type="password"
            class="text-input"
            :value="password_confirmation"
            placeholder="Confirm password"
            spellcheck="false"
            @input="password_confirmation = $event.target.value"
          />
          <span v-if="formErrors.length" :class="['help is-danger']">
            {{ formErrors[0].password_confirmation }}
          </span>
        </div>
      </div>
      <div class="buttons">
        <button
          class="button confirm"
          type="submit"
          :class="{ 'is-loading': loadingClass === 'loading' }"
          :disabled="isDisabled"
        >
          <span>Set password</span>
        </button>
      </div>
    </form>
  </base-modal>
</template>

<script>
import { mapActions } from 'vuex';
import BaseModal from '@components/modals/BaseModal.vue';

export default {
  components: {
    BaseModal,
  },
  props: {
    modalMessage: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      password: '',
      password_confirmation: '',
      formErrors: [],
      loadingClass: null,
      isDisabled: false,
    };
  },

  computed: {},

  methods: {
    ...mapActions('user/account', ['updatePassword']),

    onSubmit() {
      this.loadingClass = 'loading';
      this.isDisabled = true;
      this.formErrors = [];

      this.updatePassword({
        oldPassword: null,
        password: this.password,
        passwordConfirmation: this.password_confirmation,
      })
        .then(response => {
          this.$emit('closeModal');
        })
        .catch(error => {
          const { errors } = error.response.data;
          if (Object.keys(errors).length > 0) {
            this.formErrors.push(errors);
          }
        })
        .finally(() => {
          this.loadingClass = '';
          this.isDisabled = false;
        });
    },

    onCloseModal() {
      this.$emit('closeModal');
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  padding: 20px;
}

.field {
  + .field {
    margin-top: 20px;
  }
}

input {
  padding: 10px;
  background: #252929;
  border: none;
  color: #bcbcbc;
  width: 100%;
  overflow: hidden;
  font-family: 'Open sans';
  font-size: 15px;
}

a {
  color: #db841e;
  text-decoration: none;
}

h1 {
  font-weight: 100;
  font-size: 20px;
  line-height: 1.5;
  padding: 0;
  margin: 0 0 20px 0;
}

.icon {
  display: block;
  text-align: center;
  margin: 40px auto 30px auto;
}

p {
  font-size: 15px;
  line-height: 1.5;
}

.buttons {
  display: flex;
  justify-content: flex-end;
  .button {
    font-size: 13px;
    padding: 8px 12px;
    border-radius: 3px;
    width: 100%;
    border: none;
    color: #fff;
    background: #bf751d;
    cursor: pointer;
    margin: 25px 0 0 0;
    display: inline-block;
    width: auto;
    text-align: center;

    &.confirm {
      background: #bf751d;
      border: none;

      &:hover {
        background: #db841e;
      }
    }

    &.cancel {
      border: 1px solid #6e797b;
      background: #2c3233;

      &:hover {
        background: #464b4c;
      }
    }

    &.is-loading {
      &:before {
        margin: -12px 0 0 -11px;
        width: 22px;
        height: 22px;
        position: absolute;
        left: 50%;
        top: 50%;
        content: '';
        -webkit-border-radius: 24px;
        -webkit-background-clip: padding-box;
        -moz-border-radius: 24px;
        -moz-background-clip: padding;
        border-radius: 24px;
        background-clip: padding-box;
        border: rgba(255, 255, 255, 0.25) 2px solid;
        border-top-color: #fff;
        animation: animation-rotate 2000ms linear infinite;
      }

      span {
        color: transparent;
      }
    }
  }
}

.help {
  display: block;
  font-size: 0.75rem;
  margin-top: 0.25rem;
}

.help.is-danger {
  color: #bf751d;
}

.modal-message {
  padding: 10px;
  margin: 0 0 20px;
  background-color: lighten(#bf751d, 10);
  border: 1px solid #bf751d;
  color: #ffffff;
}

@-webkit-keyframes animation-rotate {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@-moz-keyframes animation-rotate {
  100% {
    -moz-transform: rotate(360deg);
  }
}
@-o-keyframes animation-rotate {
  100% {
    -o-transform: rotate(360deg);
  }
}
@keyframes animation-rotate {
  100% {
    transform: rotate(360deg);
  }
}
</style>
